"use strict";

var timeZone = "America/Denver";
var moment = require('moment-timezone');
var debug = false;

module.exports = function coerceDate(x) {

	if (! x) return null;
	
	// console.log("*** Coercing '%s'", x);
		
	var d;
	var y = x.toString().replace(/\//g, '-');
	
	if (/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d.\d\d\dZ$/.test(y)) {
		var timestamp = Date.parse(y);
		if (isNaN(timestamp)) return null;
		var parsed = new Date(timestamp);
		d = moment.tz(parsed, timeZone);
	}
	
	else if (/^\d\d\d\d-\d{1,2}-\d{1,2}$/.test(y)) {
		d = moment.tz(y, "YYYY-MM-DD", timeZone);
		if (debug) console.log("Coercing YYYY-MM-DD: %s", d);
	}
	
	else if (/^\d{1,2}-\d{1,2}-\d\d\d\d$/.test(y)) {
		d = moment.tz(y, "MM-DD-YYYY", timeZone);
		if (debug) console.log("Coercing MM-DD-YYYY: %s", d);
	}

	else if (/^(\d\d\d\d-\d{1,2}-\d{1,2}) \d\d\:\d\d/.test(y)) {
		d = moment.tz(y, "YYYY-MM-DD HH:mm", timeZone);
		if (debug) console.log("Coercing YYYY-MM-DD HH:mm: %s", d);
	}
	
	else if (/^(\d{1,2}-\d{1,2}-\d\d)$/.test(y)) {
		d = moment.tz(y, "M-D-YY", "en", timeZone);
		if (debug) console.log("Coercing M-D-YY: %s", d);
	}
	
	else if (/^(\d{8})$/.test(y)) {
		d = moment.tz(y, "YYYYMMDD", timeZone);
		if (debug) console.log("Coercing YYYYMMDD %s", d);
	}
	
	else if (/^(\d\d\d\d-\d\d)/.test(y)) {
		d = moment.tz(y + '-15', "YYYY-MM-DD", timeZone);
		if (debug) console.log("Coercing YYYYMMDD %s", d);
	}

	else if (/^[a-fA-F0-9]{24}$/.test(y)) {
		// Convert a mongo ID
		let timestamp = y.substring(0,8);
		d = new Date( parseInt( timestamp, 16 ) * 1000 );
		d = moment(d);
	}
	
	else {
		var timestamp = Date.parse(y);
		if (isNaN(timestamp)) return null;
		var parsed = new Date(timestamp);
		d = moment.tz(parsed, timeZone);
		if (debug) console.log("Coercing blind '%s' %s", x, d);
	}
	
	if (! d) return null;
	if (! d.isValid()) return null;
	
	return d.toDate();
	
};